import React, { ErrorInfo } from 'react'
import ErrorPage from 'src/pages/errorPage/ErrorPage'

interface Props {
  children?: React.ReactNode
  onError?: () => void
}

interface State {
  hasError?: boolean
}

class DesktopWindowErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    console.log('catchedDerived')
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
    console.log('catched')
    this.props.onError?.()
    console.error('Uncaught error:', error, errorInfo)
  }

  public render() {
    if (this.state.hasError) {
      return <ErrorPage />
    }
    return this.props.children
  }
}

export default DesktopWindowErrorBoundary
